import React, { useState } from "react";
import { getCachedScript } from "../../utils/scriptCache.js";
import "../EaseKey/EaseKey.css";
import "./EaseCopyPasteButtons.css";

const EaseCopyPasteButtons = ({ currentUser }) => {
  const [data, setData] = useState(false);

  const handleClick = (script, argument) => {
    const code = getCachedScript();
    if (!code) {
      return;
    }
    window.jsx.evalScript(`run(${script}(${argument}));`, function (result) {
      if (result && result !== "undefined") {
        setData(result);
      }
    });
  };

  // if (!currentUser || currentUser.role !== "admin") {
  //   return null;
  // }

  return (
    <div className="ease-copy-paste-buttons">
      <div className="ease-copy-paste__container">
        <div
          onClick={() => handleClick("ae2EaseCopy", "")}
          className="ease-copy-paste-button"
        >
          <span>Copy Ease</span>
        </div>
        <div
          onClick={() => handleClick("ae2EasePaste", data)}
          className="ease-copy-paste-button"
        >
          <span>Paste Ease</span>
        </div>
      </div>
    </div>
  );
};

export default EaseCopyPasteButtons;
